import { APP_NAME } from 'app-config'

import { Cohort } from 'root-constants'

import {
  UPSELL_CONFIG_BY_APP,
  UPSELL_OVERRIDES_BY_COHORT,
} from '../pages/Upsell/components/CommonUpsell/constants'

export const getUpsellConfig = (cohortToUse: Cohort) => {
  const baseConfig = UPSELL_CONFIG_BY_APP[APP_NAME]
  const cohortOverride = UPSELL_OVERRIDES_BY_COHORT[cohortToUse] ?? {}

  return {
    ...baseConfig,
    ...cohortOverride,
  }
}
